const LOGISTICS_ADMIN_ROUTE_NAMES = {
  ADD_TENTATIVE_PICKUP_STOPS: 'add-tentative-pickup-stops',
  BUYER_VERIFICATION: 'buyer-verification',
  CONFIRM_INVENTORY_TASK: 'inventory-task',
  CREATE_BUYER: 'create-buyer',
  DEFAULT_BUYER_STORE_HOURS: 'default-buyer-store-hours',
  DELIVERY: 'delivery',
  ETOS_MANAGER: 'etos-manager',
  INBOUND_ORDER_MAPPING: 'inbound-order-mapping',
  ITEMS: 'items',
  ITEMS_CREATE_MAPPING: 'items-create-mapping',
  ITEMS_EDIT_MAPPING: 'items-edit-mapping',
  PICK_UP: 'pickup',
  TRANSFERS: 'transfers',
  UNVERIFIED_BUYERS: 'unverified-buyers',
  UNLINKED_CUSTOMERS: 'unlinked-customers',
  WILDCARD: 'wildcard',
};

export const ADMIN_ROUTE_NAMES = {
  REPLENISHMENT_ORDER_MANAGEMENT: 'replenishment-order-management',
  REPLENISHMENT_RETAILER_MANAGEMENT: 'replenishment-retailer-management',
  REPLENISHMENT_RETAILER_MANAGEMENT_EDIT: 'replenishment-retailer-management-edit',
  IMPORT_PRODUCTS: 'import-products',
  INGESTION_LIST: 'ingestion-list',
  INGESTION_ITEMS: 'ingestion-items',
  ORDER_CO_MANAGEMENT: 'order-co',
  WEBHOOK_BACKFILLS_MANAGEMENT: 'webhook-backfill-management',
  ...LOGISTICS_ADMIN_ROUTE_NAMES,
};
